// Batch 27 · Add-on 3 · C (M41) — one registry of "this screen has unsaved changes". A form marks itself dirty / clean;
// nothing reloads the page by itself while any is dirty (the new-version banner and the chunk-error reload both ask it).
// Batch 28 · Follow-up 1 · F2 — a dirty entry may also give its Save, so the session warning can offer "Save now", and
// confirmLeave() asks once before the engagement changes, a dialog closes or a tab / head switches.
import { askConfirm } from "@/lib/appDialog";

export const UNSAVED_TEXT = {
  en: { leave: "You have unsaved changes on this page. Leave without saving?",
        discard: "You have unsaved changes. Discard them and continue?" },
  ar: { leave: "لديك تغييرات غير محفوظة في هذه الصفحة. هل تغادر دون حفظ؟",
        discard: "لديك تغييرات غير محفوظة. هل تتجاهلها وتتابع؟" },
};

const dirty = new Set();
const savers = new Map();
const listeners = new Set();
const emit = () => listeners.forEach((fn) => { try { fn(); } catch (e) { /* a listener never breaks the registry */ } });

export function setUnsaved(key, isDirty, save) {
  if (isDirty) { dirty.add(key); if (save) savers.set(key, save); else savers.delete(key); }
  else { dirty.delete(key); savers.delete(key); }
  emit();
}
export function hasUnsaved() { return dirty.size > 0; }
export function subscribeUnsaved(fn) { listeners.add(fn); return () => listeners.delete(fn); }
/** Runs the Save of every dirty entry that gave one (one after the other). Resolves the number of saves started. */
export async function saveAllUnsaved() {
  const fns = [...savers.values()];
  for (const fn of fns) { try { await fn(); } catch (e) { /* the screen shows its own error */ } }
  return fns.length;
}
/** Asks once when anything is unsaved; resolves true to go on. kind: "leave" (another page / engagement) or "discard". */
export function confirmLeave(lang = "en", kind = "leave") {
  if (!hasUnsaved()) return Promise.resolve(true);
  const L = UNSAVED_TEXT[lang === "ar" ? "ar" : "en"];
  return askConfirm(kind === "discard" ? L.discard : L.leave);
}
/** Same question for one screen's own dirty flag (a dialog closing, a tab or head switching inside it). */
export function confirmDiscard(isDirty, lang = "en") {
  if (!isDirty) return Promise.resolve(true);
  return askConfirm(UNSAVED_TEXT[lang === "ar" ? "ar" : "en"].discard);
}
export function _resetUnsaved() { dirty.clear(); savers.clear(); emit(); }     // tests
